import { CLASS_NIVEAU_DISPONIBILITE } from '@/configuration/catalogue/disponibiliteConf';

export default function calculDisponibiliteLc(disponibilites) {
  const result = {};
  const listeRAV = disponibilites.map(d => d.stock - d.vendu);
  result.resteAVendreMin = Math.min(...listeRAV);
  result.resteAVendreMax = Math.max(...listeRAV);

  result.disponibiliteCss = CLASS_NIVEAU_DISPONIBILITE[2];
  if (result.resteAVendreMin <= 0 && result.resteAVendreMax <= 0) {
    result.disponibiliteCss = CLASS_NIVEAU_DISPONIBILITE[1];
  }
  if (result.resteAVendreMin >= 1) result.disponibiliteCss = CLASS_NIVEAU_DISPONIBILITE[3];
  return result;
}
